import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

const useOfferReviewPageStyles = makeStyles()((theme: Theme) => ({
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  subTitle: {
    marginBottom: theme.spacing(3),
  },

  shortDescription: {
    marginTop: theme.spacing(2),
  },

  disclaimer: {
    marginBottom: theme.spacing(1),
    '& a': {
      textDecoration: 'underline',
      color: 'inherit',
    },
  },

  additionalPadding: {
    marginBottom: theme.spacing(2),
  },

  contactCustomerSwitchWrapper: {
    margin: '0 20px 10px 20px',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      margin: '0 5px 10px 10px',
    },
    ...theme.brand.assets.layout?.contactCustomerSwitchWrapper,
  },

  backgroundImage: {
    [theme.breakpoints.up('md')]: {
      ...theme.brand.assets.pageBackgrounds.review,
    },
  },
}))

export default useOfferReviewPageStyles
